import {
  fetchFaqFail,
  fetchFaqRequest,
  fetchFaqSuccess
} from '../store/ActionReducers/faq.actionreducer';
import {Dispatch} from 'redux';
import { httpbase } from '../utils/axios.utils';
import { lang } from '../config/app.config';

export const fetchFaq = (page:number = 1)=>{
  return async (dispatch:Dispatch) =>{
    dispatch(fetchFaqRequest());
    try{
      const response = await httpbase().get(`resources/faq-category?lang=${lang}`);
      const faqs = response.data.data || undefined;
      // const meta = response.data.meta || undefined;
      dispatch(fetchFaqSuccess({faqs:faqs}));
    }catch(e:any){
      if(e && e.response && e.response.data){
        dispatch(fetchFaqFail(e.response.data));
      }
      dispatch(fetchFaqFail("Something went wrong!"));
    }
  }
}